/* eslint-disable keyword-spacing */
import { Directive, ElementRef, OnInit, inject } from '@angular/core';
import { NgControl, NgModel } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[formControlName]',
})
export class CmgFormControlDomDirective implements OnInit {
  private readonly _el = inject(ElementRef);
  private readonly _control = inject(NgControl);
  private readonly _model = inject(NgModel, { optional: true });

  ngOnInit() {
    if (this._model) {
      (<any>this._model.control).nativeElement = this._el.nativeElement;
    } else if (this._control && this._control.control) {
      (<any>this._control.control).nativeElement = this._el.nativeElement;
    }
  }
}
